/**
 * @file Reacts to notification permission status, works both for web and native
 */

import { getIsReactNativeWebView } from '../../utils/webview/helpers';
import useNativeFirebaseInfo from '../native/useNativeFirebaseInfo';
import usePermissionStatus from '../usePermissionStatus';

const mapping: Record<PermissionState, NotificationPermission> = {
  denied: 'denied',
  granted: 'granted',
  prompt: 'default',
};

/**
 * Get the status for notification permissions
 * Works both for PWA and native (within webview)
 *
 * It's null when the data is being processed
 * (occurs only when within native, on the web it's sync)
 *
 * @returns The status
 */
const useNotificationPermissionStatus = (): NotificationPermission | null => {
  const permissionWeb = usePermissionStatus('notifications');
  const firebaseInfo = useNativeFirebaseInfo();

  const isReactNativeWebView = getIsReactNativeWebView();

  if (isReactNativeWebView) {
    return firebaseInfo?.notificationPermission ?? null;
  }

  // This is more reliable than the permission status
  // But is not available on Safari when the PWA is not installed
  if ('Notification' in globalThis) {
    return Notification.permission;
  }

  return permissionWeb ? mapping[permissionWeb] : null;
};

export default useNotificationPermissionStatus;
